<template lang="html">
  <main>
    <div class="first-screen">
      
      <img v-if="$whitelabel === 'digifarm'" class="logo digifarm" src="@/assets/digifarm-logo.png" alt="logo">
      <img v-else class="logo" src="@/assets/logo-full.png" alt="logo">

      <div class="choose-your-path">



        <app-btn :to="`/auth/login`">
          Login to software
        </app-btn>


      </div>
    </div>
  </main>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

main {

  &#content {
    flex-direction: column;
    .first-screen {
      width:100%;
      height: 100%;
      padding: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .logo {
        width: 100%;
        max-width: 320px;
        height: auto;
        margin-bottom: 50px;
        @media (max-width:768px) {
          margin-bottom: 8px;
        }
        &.digifarm {
          max-width: 200px;
        }
      }
    }
  }

  h2 {
    text-align: center;
  }

  a {
    text-decoration: none;
  }
  .first-screen {
    .choose-your-path {
      display: flex;
      flex-direction: column;
      max-width: 1200px;
      a {
        display: flex;
        margin: 8px 24px;
        position: relative;
        justify-content: center;
        align-items: center;
        transition: .3s;
        &:hover {
          transform: scale(1.1);
        }
        img {
          position: relative;
          object-fit: cover;
          z-index: 0;
        }
        p {
          padding: 32px;
          box-sizing: border-box;
          margin: 0;
          color: #fff;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          font-size: 40px;
          font-weight: 500;
          text-transform: uppercase;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      @media (max-width: 1100px) {
        flex-direction: column;
        width: 100%;
        a {
          margin-right: 0;
          margin-left: 0;
          img {
            width: 100%;
          }
          p {
            padding: 12px;
            font-size: 32px;
          }
        }
      }
      @media (max-width: 550px) {
        a {
          p {
            font-size: 24px;
          }
        }
      }
    }
  }


}


</style>
